import { ShieldCheck } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import MfaEnrollmentPanel from './MfaEnrollmentPanel';

// Full-screen forced enrollment: shown when the firm's policy (or the firm
// admin capability) requires MFA and no authenticator is enrolled yet. The
// only ways forward are enrolling or signing out.
export default function MfaEnrollmentScreen() {
  const { signOut, refreshMfaGate, mfaRequirements } = useAuth();

  const reason =
    mfaRequirements?.firm_policy === 'all'
      ? 'Your firm requires two-factor authentication for all members.'
      : 'Your firm requires two-factor authentication for firm administrators.';

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-md border border-gray-200 max-w-md w-full p-6" data-testid="mfa-enrollment-screen">
        <div className="flex items-center gap-3 mb-2">
          <ShieldCheck className="w-6 h-6 text-blue-700" />
          <h1 className="text-lg font-bold text-gray-900">Set up two-factor authentication</h1>
        </div>
        <p className="text-sm text-gray-600 mb-5">{reason}</p>
        <MfaEnrollmentPanel onComplete={refreshMfaGate} />
        <div className="mt-6 pt-4 border-t border-gray-200 text-center">
          <button
            onClick={() => void signOut()}
            data-testid="mfa-signout"
            className="text-sm text-gray-500 hover:text-gray-700"
          >
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
